import { IonButton, IonCard, IonCardContent, IonIcon } from '@ionic/react';
import { cardOutline } from 'ionicons/icons';
import { useHistory } from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation';
import { useRequiredDevicePaymentPlanInfo } from '../query/hasRequiredDevicePaymentPlan';
import styles from './RequiredPaymentBanner.module.css';

const RequiredPaymentBanner: React.FC = () => {
    const { t } = useTranslation('components');
    const history = useHistory();
    const { requiredDeviceIds, totalDeviceCount } = useRequiredDevicePaymentPlanInfo();

    if (requiredDeviceIds.length === 0) {
        return null;
    }

    const isSingleDevice = totalDeviceCount === 1;

    return (
        <IonCard className={styles.card}>
            <IonCardContent className={styles.content}>
                <div className={styles.iconChip}>
                    <IonIcon icon={cardOutline} />
                </div>
                <div className={styles.text}>
                    <div className={styles.title}>{t('required_payment_banner.title')}</div>
                    <div className={styles.subtitle}>{t(isSingleDevice ? 'required_payment_banner.subtitle_single' : 'required_payment_banner.subtitle')}</div>
                </div>
                <IonButton
                    className={styles.action}
                    fill="solid"
                    color="danger"
                    size="small"
                    onClick={() => history.push(isSingleDevice ? `/devices/${requiredDeviceIds[0]}` : '/devices')}
                >
                    {t('required_payment_banner.action')}
                </IonButton>
            </IonCardContent>
        </IonCard>
    );
};

export default RequiredPaymentBanner;
